/** One row of a top list: the name, the count and the bar width against the first row. */
export interface MeterRow {
  key: string;
  name: string;
  value: number;
  /** 0-100. */
  widthPct: number;
  color?: string;
}

/** The rows of a top list in the Smartlinks block, largest first, at most `limit` (design a1: 3). */
export function meterRows(
  items: { key: string; name: string; value: number; color?: string }[],
  limit: number
): MeterRow[] {
  const top = [...items].sort((a, b) => b.value - a.value).slice(0, limit);
  const max = top[0]?.value ?? 0;
  return top.map((item) => ({ ...item, widthPct: max > 0 ? Math.round((item.value / max) * 100) : 0 }));
}
